import { getAccessToken, removeAccessToken } from "./cookie";
import { safeLocalStorage } from "./storage";

const handleLogout = () => {
   removeAccessToken();
   safeLocalStorage.clear();

   if (typeof window !== "undefined") {
      const locale = window.location.pathname.split("/")[1] || "vi";
      window.location.href = `/${locale}/auth/login`;
   }
};

const handleTokenCheck = () => {
   const token = getAccessToken();
   if (!token) {
      handleLogout();
      return false;
   }

   try {
      const tokenParts = token.split(".");
      if (tokenParts.length !== 3) {
         handleLogout();
         return false;
      }

      const payload = JSON.parse(atob(tokenParts[1]));
      if (payload.exp && Date.now() >= payload.exp * 1000) {
         handleLogout();
         return false;
      }

      return true;
   } catch (error) {
      handleLogout();
      return false;
   }
};

export const fetchWithAuth = async (
   url: string,
   options: RequestInit = {},
   cache: RequestCache = "default"
) => {
   if (!handleTokenCheck()) {
      throw new Error("Unauthorized");
   }

   const token = getAccessToken();
   const headers = new Headers(options.headers);
   headers.set("Authorization", `Bearer ${token}`);

   if (!(options.body instanceof FormData)) {
      headers.set("Content-Type", "application/json");
   }

   return fetch(url, {
      ...options,
      cache,
      headers
   });
};
